<template>
    <v-textarea
        :value="value"
        v-bind="$attrs"
        outlined
        :label="label"
        :maxlength="maxLength"
        :error-messages="errorMessages"
        class="mt-0 pt-0"
        :hide-details="hideDetails"
        :placeholder="placeholder"
        @keypress="$emit('keypress', $event)"
        @input="$emit('input', $event)"
        @click:append="$emit('click:append', $event)"
    />
</template>

<script>
import {computed} from "@vue/composition-api";

export default {
    name: "TextField",
    props: {
        errorMessages: {
            type: [String, Array],
            default: () => []
        },
        bindProps: {
            type: Object,
            default: null
        },
        value: {
            type: [String, Number],
            default: ""
        },
        placeholder: {
            type: String,
            default: ""
        },
        label: {
            type: String,
            default: ""
        },
        maxLength: {
            type: [Number, String],
            default: null
        }
    },
    setup(props) {
        const hideDetails = computed(() => {
            if (props.errorMessages && !props.errorMessages.length) {
                return true
            }

            if (props.errorMessages) {
                return false
            }

            if (props.bindProps && props.bindProps.hideDetails) {
                return true
            }

            return true
        })

        return {
            hideDetails
        }
    }
}
</script>
